import { useState } from 'react'

import { EMPTY_STRING } from '../../../../../../constants/common'
import { useDebouncedState } from '../../../../../../hooks'
import { REQUEST_PROFILE_TAB_EMAILS_SEARCH_TIMEOUT } from '../../../RequestProfileTabEmails.constants'

import { getRequestProfileTabEmailsSearchFilters } from './useRequestProfileTabEmailsSearch.utils'

export function useRequestProfileTabEmailsSearch() {
  const [search, setSearch] = useState(EMPTY_STRING)

  const [searchQuery, setSearchQuery] = useDebouncedState(EMPTY_STRING)

  const searchFilters = getRequestProfileTabEmailsSearchFilters(searchQuery)

  // Resolves with the applied term once the debounce fires; a superseded call never settles.
  async function handleChangeSearch({ target: { value } }) {
    const nextSearchQuery = value.trim()

    setSearch(value)

    await setSearchQuery(
      nextSearchQuery,
      REQUEST_PROFILE_TAB_EMAILS_SEARCH_TIMEOUT
    )

    return nextSearchQuery
  }

  function handleClearSearch() {
    setSearch(EMPTY_STRING)
    setSearchQuery(EMPTY_STRING)
  }

  return {
    handleChangeSearch,
    handleClearSearch,
    isSearchActive: searchQuery.length > 0,
    search,
    searchFilters,
  }
}
